import React from 'react';
import styled from 'styled-components';
import FlexboxContainer from 'components/UI/FlexboxContainer';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FontWeight } from 'lib/styles';
import { Text } from 'styles/themeColors';
import * as Cons from 'data/Consignment';
import { TEXT_LABELS } from 'constants/order';
import { DateTime } from 'luxon';

const LabelText = styled.span`
  display: block;
  font-weight: ${FontWeight.medium};
  text-align: left;
  margin-bottom: 5px;
  color: ${Text.primary};
  font-size: 15px;
`;

interface Props {
  shippingConsignmentRequest: Cons.ShippingConsignmentRequest;
  consignmentData: Cons.ConsignmentRentDates;
}

export default function RentalNewDates({ consignmentData, shippingConsignmentRequest}: Props) {
  return (
    <>
      <FlexboxContainer flexDirection="row" width="100%" margin="10px 0px" gap="8px">
        <FlexboxContainer
          flexDirection="column"
          width="50%"
        >
          <LabelText>{TEXT_LABELS.CURRENT_START_DATE}</LabelText>
          <DatePicker
            value={consignmentData.rentalStartDate ? DateTime.fromISO(consignmentData.rentalStartDate) : null}
            format="yyyy MMM dd"
            slotProps={{ textField: { size: 'small', sx: { width: '100%' } } }}
            onChange={() => {}}
            disabled
          />
        </FlexboxContainer>
        <FlexboxContainer
          flexDirection="column"
          width="50%"
        >
          <LabelText>{TEXT_LABELS.CURRENT_END_DATE}</LabelText>
          <DatePicker
            value={consignmentData.rentalEndDate ? DateTime.fromISO(consignmentData.rentalEndDate) : null}
            format="yyyy MMM dd"
            slotProps={{ textField: { size: 'small', sx: { width: '100%' } } }}
            onChange={() => {}}
            disabled
          />
        </FlexboxContainer>
      </FlexboxContainer>
    </>
  );
}
